const baseUrl = "https://ghumfir003.pythonanywhere.com/api";

export default baseUrl;